
<div class="preview-step">
    <h4 class="mt-3"><b>Email Preview</b></h4>
    <p class="text-muted mb-4">Preview how your scheduled email will look when sent.</p>

    <!-- Email Preview Card -->
    <div class="d-flex justify-content-center">
        <!-- Reserve space so the recipient line truncates before the SAMPLE ribbon. -->
        <EmailPreviewCard
            :report-data="reportData"
            :card-style="{ maxWidth: '880px', '--ribbon-safe-padding': '25px' }"
        />
    </div>

    <!-- Schedule Summary -->
    <ScheduleSummaryCard :report-data="reportData" />
</div>
